import React from "react";
import "./App.css";
import Header from "./components/Header";
import Home from "./components/Home";
import Services from "./components/Services";
import Project from "./components/Project";
import About from "./components/About";
import Stats from "./components/Stats";
import Testimonials from "./components/Testimonials";
import TermsandConditions from "./components/TermsandConditions";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Home />
      <Services />
      <Project />
      <About />
      <Stats />
      <Testimonials />
      <TermsandConditions />
      <Pricing />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
